import { Button } from '@mui/material';
import React from 'react';

const VARIANT_STYLES = {
  primary: {
    backgroundColor: 'orange.500',
    color: 'gray.700',
    '&:hover, &:focus': {
      backgroundColor: 'orange.700',
    },
    '&:active': {
      backgroundColor: 'orange.900',
    },
  },
  secondary: {
    backgroundColor: 'grey.300',
    color: 'common.black',
    '&:hover, &:focus': {
      backgroundColor: 'grey.400',
    },
    '&:active': {
      backgroundColor: 'grey.500',
    },
  },
};

export default function NavButton({ sx, children, variant = 'primary', ...props }) {
  return (
    <Button
      sx={{
        display: 'block',
        textAlign: 'center',
        width: '100%',
        maxWidth: '750px',
        mt: 3,
        mx: 'auto',
        px: { xs: 2.5, sm: 9 },
        py: 1.5,
        textTransform: 'none',
        fontWeight: 700,
        textDecoration: 'none',
        fontSize: '0.875rem',
        ...VARIANT_STYLES[variant],
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
}
